import { graphql, useStaticQuery } from 'gatsby';
import useLivePreviewSetup from 'helpers/useLivePreviewSetup';
import { FooterNavBarData, SectionsData } from './types';

const FooterQuery = graphql`
  query {
    allCsCustomisableFooter {
      nodes {
        cslp__meta
        locale
        sections {
          simple_section {
            links {
              open_in_new_tab
              text
              url
            }
            title
          }
          icon_section {
            title
            links_with_images {
              image {
                ...Asset
              }
              link {
                open_in_new_tab
                text
                url
              }
            }
          }
          rich_text_section {
            body
            title
          }
        }
        footer_compliance {
          compliance
        }
        footer_nav_bar {
          links {
            text
            url
          }
        }
      }
    }
  }
`;

export type CustomisableFooterData = SectionsData & {
  footer_compliance: {
    compliance: string;
  };
  footer_nav_bar: FooterNavBarData;
  locale: string;
  cslp__meta: unknown;
};

export type CustomisableFooterProps = {
  allCsCustomisableFooter: { nodes: CustomisableFooterData[] };
};

const useFooterData = (locale: string): CustomisableFooterData => {
  const { allCsCustomisableFooter } =
    useStaticQuery<CustomisableFooterProps>(FooterQuery);

  const csCustomisableFooter = allCsCustomisableFooter.nodes.find(
    (customisableFooter) => customisableFooter.locale === locale
  );

  const footerData = useLivePreviewSetup(csCustomisableFooter);

  if (!footerData) {
    throw new Error(`Customisable Footer for locale: ${locale} is missing!`);
  }

  return footerData;
};

export default useFooterData;
